import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OnlineUseEffects, onlineUseReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([OnlineUseEffects]), StoreModule.forFeature(`onlineUse`, onlineUseReducer)]
})
export class OnlineUseStateModule {}
